import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container: 'container',
    search: 'grow',
    base: 'flex items-end gap-30 max-lg:gap-20 max-md:flex-col max-md:items-stretch max-md:gap-8',
    sort: '',
    sortButton: 'heading-m-bold flex cursor-pointer items-center gap-2',
    sortButtonIcon: 'text-main mt-0.5 size-6 rotate-90 transition-transform'
  },
  variants: {
    open: {
      true: {
        sortButtonIcon: 'scale-x-[-1]'
      }
    }
  }
});
